import React, { useCallback, useEffect, useRef, useState } from "react";
import PopupModal from "../../common/PopupModal";
import "./refreshToken.scss";
import { useDispatch } from "react-redux";
import { fetchMyaccountLogin } from "../../store/Myaccount/myaccountActions";
import { useNavigate } from "react-router-dom";

const SESSION_LOGOUT_MS = 120000;

const RefreshToken = ({ isPopupOpen, closeCallback = () => {} }) => {
  const [isModalOpen, setIsModalOpen] = useState(isPopupOpen);
  const logoutTimerRef = useRef(null);
  const dispatch = useDispatch();
  const navigateTo = useNavigate();

  const clearLogoutTimer = useCallback(() => {
    clearTimeout(logoutTimerRef.current);
    logoutTimerRef.current = null;
  }, []);

  const handleResetOnClose = useCallback(() => {
    clearLogoutTimer();
    localStorage.removeItem("auth-key");
    localStorage.removeItem("userName");
    window.location.reload();
    setIsModalOpen(false);
    closeCallback();
    navigateTo("/login");
  }, [clearLogoutTimer, closeCallback, navigateTo]);

  useEffect(() => {
    if (isModalOpen) {
      logoutTimerRef.current = setTimeout(() => {
        handleResetOnClose();
      }, SESSION_LOGOUT_MS);
    }

    return clearLogoutTimer;
  }, [isModalOpen, handleResetOnClose, clearLogoutTimer]);

  const handleCloseModal = () => {
    handleResetOnClose();
  };

  const handleFetchToken = () => {
    clearLogoutTimer();
    dispatch(fetchMyaccountLogin()).then((result) => {
      if (result.payload?.success) {
        setIsModalOpen(false);
        closeCallback();
        return;
      }

      logoutTimerRef.current = setTimeout(() => {
        handleResetOnClose();
      }, SESSION_LOGOUT_MS);
    });
  };

  const RenderTimeoutContent = () => {
    return (
      <div className="timeout-info-content">
        <div className="row timeout-message">
          <div className="col-md-12">
            <div className="message-container">
              <p className="session-timeout-text">
                Your session will end in 2 minutes due to inactivity
              </p>
              <p className="timeout-text">
                As a security precaution, if your session is idle, the session
                will end and you will be brought to the login page.
              </p>
              <p className="timeout-text">
                If you are still working, click Ok to continue
              </p>
              <div className="button-container">
                <button
                  onClick={handleFetchToken}
                  className="btn ok-btn"
                  aria-label="Close timeout warning"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="session-timeout-wrapper">
      {isModalOpen && (
        <PopupModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          customRender={RenderTimeoutContent}
          popupType="center"
          width="600px"
        />
      )}
    </div>
  );
};

export default RefreshToken;
